import React, {useRef, useEffect} from 'react';
import classNames from 'classnames';
import useCommon from '@utils/hooks/common';
import styles from './styles';

interface EmojiButtonProps {
  isDisabled: boolean;
  onClick: () => void;
  size?: number;
}

const EmojiButton: React.FC<EmojiButtonProps> = ({isDisabled, onClick, size = 23}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const {classes} = useCommon({
    withStyles: styles,
  });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let animationFrameId: number;
    let scale = 1;
    let increasing = true;

    const img = new Image();
    img.src = '/icon/send-emoji-icon.svg';

    img.onload = () => {
      const drawButton = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw circle with box shadow
        ctx.save();
        ctx.shadowColor = 'rgba(255, 255, 255, 0.4)';
        ctx.shadowBlur = 4;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 1;
        ctx.beginPath();
        ctx.arc(canvas.width / 2, canvas.height / 2, (canvas.width / 2) * scale, 0, 2 * Math.PI);
        ctx.fillStyle = isDisabled ? '#200049' : '#200049';
        ctx.fill();
        ctx.restore();

        // Draw emoji icon
        const imgSize = 12 * scale;
        ctx.drawImage(
          img,
          (canvas.width - imgSize) / 2,
          (canvas.height - imgSize) / 2,
          imgSize,
          imgSize
        );

        // Apply filter for disabled state
        if (isDisabled) {
          ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';

          ctx.arc(canvas.width / 2, canvas.height / 2, canvas.height / 2, 0, 2 * Math.PI);
          ctx.fill();
        }

        // Animation
        if (!isDisabled) {
          if (increasing) {
            scale += 0.01;
            if (scale >= 1) increasing = false;
          } else {
            scale -= 0.01;
            if (scale <= 0.75) increasing = true;
          }
        }

        animationFrameId = requestAnimationFrame(drawButton);
      };

      drawButton();
    };

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [isDisabled]);

  const handleClick = () => {
    if (!isDisabled) {
      onClick();
    }
  };

  return (
    <div
      className={classNames(classes.emojiButton, {
        'ant-btn-disabled': isDisabled,
        // darken: isDisabled,
      })}
      style={{width: size, height: size}}
      onClick={handleClick}
    >
      <canvas ref={canvasRef} width={size} height={size} className={classes.emojiCanvas} />
    </div>
  );
};

export default EmojiButton;
